import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as _ from 'lodash';
import { Field } from 'formik';

import FieldUtil from '../utils/FieldNames';

import '../../../../app/assets/stylesheets/rte_edit_payer.scss';

class PayerInfo extends Component {

  transformFieldName(field) {
    switch (field) {
      case 'payer_id': return 'Payer ID';
      case 'payer_cd': return 'Payer Code';
      case 'payer_nm': return 'Name';
      case 'active_flg': return 'Active?';
      case 'allow_group_mover_flg': return 'Group Mover?';
      case 'supported_service_specialties_list': return 'Specialties';
      default: return '';
    }
  }

  render() {
    return (
      <div className="payer_info">
        <div className="fields">
          {FieldUtil.infoFields.map((field, i) => (
            <div className="accum_keys" key={i}>
              <p><b>{this.transformFieldName(field)}</b></p>
            </div>
          ))}
          <div className="accum_keys">
            <p><b>DB Payer Rules Active?</b></p>
          </div>
        </div>
        <div className="field_values">
          {FieldUtil.infoFields.map((field, i) => (
            <div className="accum_keys" key={i}>
              <p><b>{_.get(this.props.payer, [field]) || '---'}</b></p>
            </div>
          ))}

          <div className="accum_keys">
            <p>
              <Field
                name="payer_config.active_flg"
                render={({ field }) => (
                  <input
                    {...field}
                    type="checkbox"
                    onChange={this.props.handleChange}
                    style={{ zoom: '1.5' }}
                    disabled={this.props.mode !== 'edit'}
                    checked={field.value}
                  />
                )}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

PayerInfo.propTypes = {
  payer:        PropTypes.object,
  handleChange: PropTypes.func,
  mode:         PropTypes.string
};

export default PayerInfo;
